import MarkdownIt from 'markdown-it'
export default function () {
    const md = new MarkdownIt({
        linkify: true,
        breaks: true
    })

    md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
        const token = tokens[idx]

        // add target="_blank"
        const targetIndex = token.attrIndex('target')
        if (targetIndex < 0) {
            token.attrPush(['target', '_blank'])
        } else {
            token.attrs[targetIndex][1] = '_blank'
        }

        // add rel
        token.attrPush(['rel', 'noopener noreferrer'])

        return self.renderToken(tokens, idx, options)
    }

    // Keep original render method and wrap it to clean up empty lists
    const originalRender = md.render.bind(md)

    md.render = function (src = '', env = {}) {
        let html = originalRender(src, env)

        // Remove individual empty <li> elements (optionally wrapped with <p>, whitespace, <br>, &nbsp;)
        html = html.replace(/<li[^>]*>\s*(?:<p[^>]*>\s*)?(?:&nbsp;|\s|<br\s*\/?>)*\s*(?:<\/p>)?\s*<\/li>/gi, '')

        // Remove lists (<ul> and <ol>) that contain only empty <li> (after empty <li> removal)
        html = html.replace(/<(ul|ol)([^>]*)>\s*(?:<li[^>]*>\s*(?:<p[^>]*>\s*)?(?:&nbsp;|\s|<br\s*\/?>)*\s*(?:<\/p>)?\s*<\/li>\s*)+<\/(?:ul|ol)>/gi, '')

        // Add class "single" to <ul> elements that contain exactly one <li>
        html = html.replace(/<ul([^>]*)>([\s\S]*?)<\/ul>/gi, function (match, attrs, inner) {
            const liMatches = inner.match(/<li\b[^>]*>/gi)
            const count = liMatches ? liMatches.length : 0
            if (count === 1) {
                if (/class\s*=\s*['"]?/i.test(attrs)) {
                    // append to existing class attribute
                    return '<ul' + attrs.replace(/class\s*=\s*(['"])(.*?)\1/i, function (m, quote, cls) {
                        const classes = cls.split(/\s+/).filter(Boolean)
                        if (!classes.includes('single')) classes.push('single')
                        return 'class=' + quote + classes.join(' ') + quote
                    }) + '>' + inner + '</ul>'
                }
                // add new class attribute (preserve spacing in attrs)
                return '<ul' + attrs + ' class="single">' + inner + '</ul>'
            }
            return '<ul' + attrs + '>' + inner + '</ul>'
        })

        // Also remove consecutive empty block-level wrappers (e.g., leftover multiple newlines)
        html = html.replace(/(?:\n\s*){2,}/g, '\n')

        return html
    }

    return md;
}
